export {QuickMessage} from './directive';